import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-71870aaa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "default-popover" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "d-flex flex-row justify-content-end p-t-4 p-l-4 p-r-4" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-delete" }, null, -1))
const _hoisted_5 = { class: "p-r-16 p-l-16 p-b-16" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RoundButton = _resolveComponent("RoundButton")!
  const _component_PopoverBase = _resolveComponent("PopoverBase")!

  return (_openBlock(), _createBlock(_component_PopoverBase, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_RoundButton, {
              "button-style": _ctx.ButtonColorPattern.FILL,
              color: _ctx.ButtonColor.GREYSCALE_DARK,
              size: _ctx.ButtonSize.X_SMALL,
              "no-box-shadow": "",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closePopover()))
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }, 8, ["button-style", "color", "size"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _renderSlot(_ctx.$slots, "default", {}, undefined, true)
          ])
        ])
      ])
    ]),
    _: 3
  }))
}